module.exports = __webpack_public_path__ + "static/media/joana_dias.5e820715.jpg";